/**
 * Post Component JavaScript
 * Handles click events and confirmations for posts
 */

class PostComponent {
    constructor() {
        this.init();
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        // Post body clicks for navigation
        document.addEventListener('click', (e) => {
            const postBody = e.target.closest('.post-body-content');
            if (postBody && !e.target.closest('a, button, [onclick]')) {
                const link = postBody.dataset.postLink;
                if (link) {
                    window.location.href = link;
                }
            }
        });

        // Confirmation dialogs
        document.addEventListener('click', (e) => {
            const confirmButton = e.target.closest('[data-confirm-message]');
            if (confirmButton) {
                const message = confirmButton.dataset.confirmMessage;
                if (!confirm(message)) {
                    e.preventDefault();
                    return false;
                }
            }
        });
    }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    new PostComponent();
});

// Export for module usage if needed
if (typeof module !== 'undefined' && module.exports) {
    module.exports = PostComponent;
}
